import { useEffect, useRef } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import tokennomicsDogImg from "../../assets/tokenomic_dog_compress.png";
import './TokenomicsSection.css';

const TokenomicsSection = () => {
  const headingRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-slide');
        }
      },
      { threshold: 0.1 }
    );

    const headingElement = headingRef.current;

    if (headingElement) {
      observer.observe(headingElement);
    }

    return () => {
      if (headingElement) {
        observer.unobserve(headingElement);
      }
    };
  }, []);

  return (
    <section className='tokenomics_section' id='tokenomics'>
      <Container>
        <Row className='align-items-center'>
          <Col md={6}>
            <div className='tokenomics_section_left'>
              <h1 ref={headingRef}>Tokenomics </h1>

              <Row className='gap-y-5 justify-content-center'>
                <Col md={5} xs={8}>
                  <div className='tokenomics_section_left_box'>
                    <h4>1 B</h4>
                    <h5>Total Supply</h5>
                  </div>
                </Col>
                <Col md={5} xs={8}>
                  <div className='tokenomics_section_left_box'>
                    <h4>OWNER</h4>
                    <h5>BURNT TOKENS</h5>
                  </div>
                </Col>
                <Col md={5} xs={8}>
                  <div className='tokenomics_section_left_box'>
                    <h4>100% LP</h4>
                    <h5>0% PRESALE</h5>
                  </div>
                </Col>
                <Col md={5} xs={8}>
                  <div className='tokenomics_section_left_box'>
                    <h4>BURNED</h4>
                    <h5>LP AT LAUNCH</h5>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
          <Col md={6}>
            <div className='tokenomics_section_right'>
              <img src={tokennomicsDogImg} alt='tokenomics' />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default TokenomicsSection